import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule, CmpsTooltipModule } from '@cmps/ng-uikit';

import { CmpsScorecardRankComponent } from './scorecard-rank.component';

@NgModule({
    declarations: [CmpsScorecardRankComponent],
    imports: [CmpsIconModule, CommonModule, CmpsTooltipModule],
    exports: [CmpsScorecardRankComponent],
})
export class CmpsScorecardRankModule {}
